import { DocumentInterruptSource, InterruptSource, StorageInterruptSource } from '@ng-idle/core';

class ZonelessDocumentInterruptSource extends DocumentInterruptSource {
  override attach(): void {
    if (!this.isAttached) {
      this.attachFn?.(this);
      this.isAttached = true;
    }
  }
}

class ZonelessStorageInterruptSource extends StorageInterruptSource {
  override attach(): void {
    if (!this.isAttached) {
      this.attachFn?.(this);
      this.isAttached = true;
    }
  }
}

export function createZonelessInterruptSources(): InterruptSource[] {
  return [
    new ZonelessDocumentInterruptSource('mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll'),
    new ZonelessStorageInterruptSource()
  ];
}
